export enum EBadgeShipping {
  ShipDirectToRep = 1,
  ShipDirectToFulfillmentCenter = 0,
}
